import { useFeatureFlagVariantKey } from 'posthog-js/react';
import { usePostVersionOverride } from '../../../utils/posthog-helpers';

const usePosthogExperiments = (): Record<string, boolean> => {
    usePostVersionOverride();

    const isCoverImageEnabled = useFeatureFlagVariantKey('addCoverImage') === 'true';

    return { isCoverImageEnabled };
};

export default usePosthogExperiments;
